import { useStyles } from './SignoffHeader.styles';
import { Box } from '@mui/material';
import { btnSize, btnType, Button } from '../../../atoms/button';
import { ProgressBar } from '../../../atoms/ProgressBar';
import { Icons } from '../../../../icons';
import { colors } from '../../../../colors';

const SignoffHeader = ({
  appointment,
  onFinsh,
  onBack,
  progressBarValue,
}) => {
  const classes = useStyles();

  // Format the patient name display to handle missing values
  const formatHeaderSubtitle = () => {
    const firstName = appointment?.patientFirstName || '';
    const lastName = appointment?.patientLastName || '';
    const uuid = appointment?.patientUuid || '';

    let displayName = '';

    // Add first name and last name with appropriate spacing
    if (firstName && lastName) {
      displayName = `${firstName} ${lastName}`;
    } else if (firstName) {
      displayName = firstName;
    } else if (lastName) {
      displayName = lastName;
    } else {
      displayName = 'Unknown Patient';
    }

    // Add UUID if available
    if (uuid) {
      displayName += ` • ${uuid}`;
    }
    if(appointment?.serviceName) {
      displayName += ` • ${appointment?.serviceName}`;
    }

    return displayName;
  };

  return (
    <Box className={classes.wrapper}>
      <Box className={classes.container}>
        {/* Header content */}
        <Box className={classes.leftActions}>
          <Button variant={btnType.OUTLINE} className={classes.backBtn} onClick={onBack}>
            <Icons color={colors.primary500} glyph="arrow-left" />
          </Button>
          <Box>
            {/* <Avatar
              variant="CIRCLE"
              src={appointment?.participantImage}
              name={`${appointment?.patientFirstName || ''} ${appointment?.patientLastName || ''}`}
              size={40}
            /> */}
              <Box className={classes.headerTitle}>Sign off on a note</Box>
              <Box className={classes.headerSubtitle}>{formatHeaderSubtitle()}</Box>
          </Box>
        </Box>
        <Box className={classes.rightActions}>
          <Button disableRipple size={btnSize.SMALL} className={classes.finishLaterBtn} variant={btnType.TEXT} onClick={onFinsh}>
            Finish later
          </Button>
          {/* <Button className={classes.signoffBtn} onClick={onSignOff} disabled={!isDisabled}>
            Sign off
          </Button> */}
        </Box>
      </Box>
      <ProgressBar value={progressBarValue} className={classes.progressBar} />
    </Box>
  );ß
};

export { SignoffHeader };
